var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2"},[_c('div',{staticClass:"visualObjectives",attrs:{"id":"visualObjectives"}})])
}]

export { render, staticRenderFns }